import { lightTheme as baseTheme, styled } from '@zenbusiness/zui/styles';

export const StatusIconStyled = styled('div')(() => ({
  position: 'absolute',
  right: '16px',
  top: '20px'
}));

export const classes = {
  empty: 'field--empty',
  valid: 'field--valid',
  invalid: 'field--invalid',
  focused: 'field--focused',
  dirty: 'field--dirty',
  touched: 'field--touched'
};

const fontCSS = {
  position: 'relative',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  color: baseTheme.palette.text.primary,
  '@font-face': {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontDisplay: 'swap',
    src: 'url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2")',
    unicodeRange:
      'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
  }
};

const styleBorder = ({ theme, isError }) => {
  if (isError) {
    return {
      border: `1px solid ${theme.palette.error.main}!important`
    };
  }
  return { border: `1px solid ${theme.palette.fixed.black}` };
};

export const LabelStyled = styled('label', {
  shouldForwardProp: (prop) => prop !== 'isError'
})(({ theme, isError }) => {
  if (isError) {
    return {
      color: `${theme.palette.error.main}!important`
    };
  }
  return {};
});

export const VGSInputStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isError' && prop !== 'maxWidth' && prop !== 'disabled'
})(({ theme, maxWidth, isError, disabled }) => ({
  ...fontCSS,
  maxWidth: maxWidth ?? '343px',
  height: '64px',
  ...styleBorder({ theme, isError }),
  borderRadius: '16px',
  cursor: disabled ? 'not-allowed' : 'text', // Add a "disabled" cursor style
  opacity: disabled ? 0.5 : 1, // Dim the component when disabled
  pointerEvents: disabled ? 'none' : 'auto', // Disable interactions
  iframe: {
    maxWidth: maxWidth ?? '343px',
    pointerEvents: disabled ? 'none' : 'auto' // Disable iframe interaction
  },
  label: {
    position: 'absolute',
    left: '16px',
    bottom: '20px',
    color: disabled ? theme.palette.text.disabled : theme.palette.text.tertiary,
    transformOrigin: '0 50%',
    cursor: disabled ? 'default' : 'text',
    pointerEvents: disabled ? 'none' : 'auto',
    transitionDuration: '0.5s',
    transitionTimingFunction: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
  },
  '&.field--focused label': {
    color: disabled ? theme.palette.text.disabled : `${theme.palette.text.primary}!important`,
    transform: disabled ? 'none' : 'scale(0.7) translate(0, -15px)',
    cursor: 'default'
  },
  '&:not(.field--empty) label': {
    color: disabled ? theme.palette.text.disabled : `${theme.palette.text.primary}`,
    transform: disabled ? 'none' : 'scale(0.7) translate(0, -15px)'
  },
  '&.field--invalid.field--touched:not(.field--empty)': {
    borderColor: disabled ? theme.palette.text.disabled : baseTheme.palette.error.main,
    '& label': {
      color: disabled ? theme.palette.text.disabled : baseTheme.palette.text.red
    }
  }
}));

export const VGSInputCSS = {
  ...fontCSS,
  maxWidth: '100%',
  height: '64px',
  border: 'none',
  padding: '0 16px',
  boxSizing: 'border-box',
  '&:focus': {
    paddingTop: '25px'
  },
  '&:focus::placeholder': {
    color: `${baseTheme.palette.text.tertiary}`
  },
  '&:not(.empty)': {
    paddingTop: '25px'
  },
  '&::placeholder': {
    color: 'transparent'
  }
};
